import { IonApp, IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthContext.jsx";
import ApiLoadingIndicator from "./components/ApiLoadingIndicator.jsx";
import PwaUpdatePrompt from "./components/PwaUpdatePrompt.jsx";
import CreateAdminAccountPage from "./pages/CreateAdminAccountPage.jsx";
import AdminSignInPage from "./pages/AdminSignInPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import JoinTeamPage from "./pages/JoinTeamPage.jsx";
import AppTabs from "./tabs/AppTabs.jsx";

function ProtectedApp() {
  const { session } = useAuth();

  return session ? <AppTabs /> : <Redirect to="/login" />;
}

function Routes() {
  const { session, loading } = useAuth();

  if (loading) {
    return null;
  }

  return (
    <IonReactRouter>
      <IonRouterOutlet>
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/login/create" component={CreateAdminAccountPage} />
        <Route exact path="/login/sign-in" component={AdminSignInPage} />
        <Route exact path="/join" component={JoinTeamPage} />
        <Route path="/app" component={ProtectedApp} />
        <Route exact path="/" render={() => <Redirect to={session ? "/app/schedule" : "/login"} />} />
      </IonRouterOutlet>
    </IonReactRouter>
  );
}

export default function App() {
  return (
    <IonApp>
      <AuthProvider>
        <ApiLoadingIndicator />
        <PwaUpdatePrompt />
        <Routes />
      </AuthProvider>
    </IonApp>
  );
}
